import { DownOutlined, UpOutlined } from '@ant-design/icons'
import { Menu } from 'antd'
import Flex from 'components/Flex'
import SideBar from 'components/Sidebar'
import { EmptyElement } from 'components/UIComponents/CommonStyledDiv'
import { navItems } from 'modules/Nav/navItems'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { PermittedNavItems } from '../../utils/permissionsValidation'
import corporateRequest from 'utils/corporateRequest'
import { SpaceItem, SubMenuItem } from './style'

const MenuStyle = styled(Menu)``
const MenuItem = styled(Menu.Item)`
  margin-top: -1.5px !important;
`

const MeneTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
  text-align: left;
  color: ${props => props.color};
  padding-left: 13px;
  line-height: 18px;
`

const TitleDiv = styled.span`
  display: block;
  width: 126px;
  overflow-wrap: break-word;
`
const SubMenuTitle = ({
  navTitle,
  pageTitle,
  parentPath,
  title,
  anotherMenu,
}) => {
  const [render, setRender] = useState(false)
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(false)

  const toggleMenu = () => {
    setIsOpen(!isOpen)
    role(navTitle)
  }
  const role = data => {
    navigate(`${parentPath}`)
    setRender(!render)
  }
  useEffect(() => {
    if (title) {
      setIsOpen(true)
      setRender(true)
    }
  }, [title])
  useEffect(() => {
    setIsOpen(false)
    setRender(false)
  }, [anotherMenu])
  return (
    <div style={{ lineHeight: 'inherit' }}>
      <SpaceItem onClick={toggleMenu}>
        <div
          style={{
            color: title == navTitle ? 'white' : '',
          }}
        >
          {pageTitle}
        </div>
      </SpaceItem>
    </div>
  )
}

const Nav = ({ permissions, corporateId }) => {
  const location = useLocation()
  const navigate = useNavigate()
  const [menuType] = useState('GlobalMenu')
  const [title, setTitle] = useState('')

  /**
   * Per-corporate feature flags, for nav items that carry `requiresFeature`.
   *
   * `null` means "not answered yet" and is deliberately distinct from `{}`
   * ("answered, nothing enabled"): while it is null the gated items are hidden
   * rather than shown-then-removed, so the menu never flickers an entry the
   * account may not be entitled to.
   *
   * Fails CLOSED. Any error leaves this as an empty object and every gated item
   * stays hidden — showing a paid product to an account without it is the worse
   * failure, and it matches how the backend gate behaves.
   */
  const [features, setFeatures] = useState(null)

  useEffect(() => {
    if (!corporateId) return undefined
    let alive = true
    corporateRequest
      .get(`/corporates/${corporateId}/feature-access`)
      .then(res => {
        if (alive) setFeatures(res?.data?.data || {})
      })
      .catch(() => {
        if (alive) setFeatures({})
      })
    return () => {
      alive = false
    }
  }, [corporateId])

  const permitted = PermittedNavItems(permissions, navItems) || []
  // A gated item is hidden until its feature is positively confirmed.
  const NavItem = permitted.map(item =>
    item?.requiresFeature && !(features && features[item.requiresFeature])
      ? { ...item, hidden: true }
      : item
  )

  const reportsSubMenu = [...NavItem]
    .find(f => f.path === '/reports')
    ?.externalMenu?.filter(item => !item?.hidden)
  const drivesSubMenu = [...NavItem]
    .find(f => f.path === '/drives')
    ?.externalMenu?.filter(item => !item?.hidden)
  const [externalMenuOpen, setExternalMenuOpen] = useState(false)
  const [driveExternalMenuOpen, setDriveExternalMenuOpen] = useState(false)
  useEffect(() => {
    const path = location?.pathname
    const parts = path.split('/') // Split the path using "/" as the delimiter
    const report = parts[1]
    if (report === 'reports') {
      const part1 = parts[2]
      if (part1 == 'role') {
        setTitle('Roles Published to Colleges')
      } else if (part1 == 'application') {
        setTitle('Candidate Application Status')
      } else if (part1 == 'drive') {
        setTitle('Applicants at Drive level')
      } else if (part1 == 'hiring') {
        setTitle('Hiring Status')
      } else {
        setTitle('Interview Schedule')
      }
      setExternalMenuOpen(true)
    }
  }, [])
  const getMenu = navItem =>
    navItem
      ?.filter(nav => !nav?.hidden)
      ?.map(item => {
        return (
          <>
            <MenuItem key={item.path} path={item.path}>
              <Flex centerVertically>
                <item.icon
                  color={
                    location.pathname?.includes(item?.path)
                      ? 'white'
                      : '#999FAC'
                  }
                />
                <MeneTitle>
                  <TitleDiv> {item?.pageTitle}</TitleDiv>
                  {item.navTitle == 'Reports' && (
                    <>
                      {externalMenuOpen ? (
                        <DownOutlined
                          style={{
                            position: 'absolute',
                            right: '0%',
                            top: '20px',
                            paddingRight: '20px',
                            color: 'white',
                          }}
                        />
                      ) : (
                        <UpOutlined
                          style={{
                            position: 'absolute',
                            right: '0%',
                            paddingRight: '20px',
                            top: '20px',
                          }}
                        />
                      )}
                    </>
                  )}
                  {item.navTitle == 'Evaluation Process' && (
                    <>
                      {driveExternalMenuOpen ? (
                        <DownOutlined
                          style={{
                            position: 'absolute',
                            right: '0%',
                            top: '20px',
                            paddingRight: '20px',
                            color: 'white',
                          }}
                        />
                      ) : (
                        <UpOutlined
                          style={{
                            position: 'absolute',
                            top: '20px',
                            right: '0%',

                            paddingRight: '20px',
                          }}
                        />
                      )}
                    </>
                  )}
                </MeneTitle>
              </Flex>
            </MenuItem>
            {item.path === '/reports' && externalMenuOpen ? (
              <SubMenuItem>
                {reportsSubMenu?.map(
                  ({ subMenu, path, navTitle, pageTitle }) => {
                    return (
                      <EmptyElement
                        key={path}
                        onClick={e => {
                          setTitle(navTitle)
                          navigate(`${path}`)
                        }}
                      >
                        <SubMenuTitle
                          navTitle={navTitle}
                          pageTitle={pageTitle}
                          subMenu={subMenu}
                          title={title}
                          parentPath={path}
                        />
                      </EmptyElement>
                    )
                  }
                )}
              </SubMenuItem>
            ) : null}
            {item.path === '/drives' && driveExternalMenuOpen ? (
              <SubMenuItem>
                {drivesSubMenu?.map(
                  ({ subMenu, path, navTitle, pageTitle }) => {
                    return (
                      <EmptyElement
                        key={path}
                        onClick={e => {
                          setTitle(navTitle)
                          navigate(`${path}`)
                        }}
                      >
                        <SubMenuTitle
                          navTitle={navTitle}
                          pageTitle={pageTitle}
                          subMenu={subMenu}
                          title={title}
                          parentPath={path}
                        />
                      </EmptyElement>
                    )
                  }
                )}
              </SubMenuItem>
            ) : null}
          </>
        )
      })

  const onItemClick = ({ item: { props } }) => {
    const { path } = props

    // Strangler-fig: /v2/* routes live in corporate-react-v2 (a separate app
    // mounted at the same origin under /v2). React-router can't client-route
    // there, so hard-navigate for a full page load (session stays shared).
    if (path?.startsWith('/v2')) {
      window.location.href = path
      return
    }

    if (path === '/reports') {
      setExternalMenuOpen(!externalMenuOpen)
      setDriveExternalMenuOpen(false)
    } else if (path === '/drives') {
      setDriveExternalMenuOpen(!driveExternalMenuOpen)
      setExternalMenuOpen(false)
    } else {
      navigate(path)
      setTitle('')
      setExternalMenuOpen(false)
      setDriveExternalMenuOpen(false)
    }
  }

  const getSelectedkey = () => {
    if (
      location.pathname.includes('/reports/role/published') ||
      location.pathname.includes('/reports/application/status') ||
      location.pathname.includes('/reports/drive/level') ||
      location.pathname.includes('/reports/hiring/status') ||
      location.pathname.includes('/reports/interview/schedule')
    ) {
      return ['/reports']
    } else if (
      location.pathname.includes('/drives') ||
      location.pathname.includes('/expcandidates')
    ) {
      return ['/drives']
    } else if (
      location.pathname.includes('/roles') ||
      location.pathname.includes('/questionaire-dashboard')
    ) {
      return ['/roles']
    } else if (location.pathname.includes('/interviewerRoles')) {
      return ['/interviewerDashboard']
    } else {
      return [location.pathname]
    }
  }

  return (
    <SideBar>
      <MenuStyle
        selectedKeys={getSelectedkey()}
        theme="dark"
        mode="inline"
        style={{ minHeight: '100vh', overflow: 'auto', paddingBottom: '8rem' }}
        inlineIndent={10}
        onClick={onItemClick}
        inlineCollapsed={false}
      >
        {getMenu(NavItem.filter(e => e.menuType === menuType))}
      </MenuStyle>
    </SideBar>
  )
}
export default Nav
